import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { Icons } from 'msp-components'
import AddressDisplay from '@/components/atoms/AddressDisplay/AddressDisplay'
import translations from './PaymentMethodDisplay.constants'
import { PaymentMethodTypeInvoiceProps } from './PaymentMethodDisplay.types'
import * as S from './PaymentMethodDisplay.styles'

const PaymentMethodTypeInvoice = ({
  className = '',
  extendedDetails,
  paymentInstrument
}: PaymentMethodTypeInvoiceProps) => {
  const { formatMessage, formatDate } = useIntl()
  const { c_billingAddress = null } = paymentInstrument
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions
  let parsedAddress = null

  try {
    parsedAddress = JSON.parse(c_billingAddress)
  } catch {
    parsedAddress = null
  }

  return (
    <div className={twMerge(S.PaymentMethodDisplayWrapper, className)}>
      <div className={S.PaymentMethodDisplayIconWrapper}>
        <Icons iconName='Invoice' size='3xl' />
      </div>
      <div className={S.PaymentMethodDisplayContentWrapper}>
        <div className={S.PaymentMethodDisplayNameWrapper}>
          {formatMessage(translations.HEIDELPAY_INVOICE)}
        </div>
        <div className={S.PaymentMethodDisplayStandardWrapper}>
          {formatMessage(translations.invoicedToBirthday, {
            birthDay: formatDate(
              paymentInstrument.c_birthday,
              dateFormattingOpts
            )
          })}
        </div>
        {parsedAddress && extendedDetails && (
          <>
            <div className={S.PaymentMethodDisplayAddressTitle}>
              {formatMessage(translations.invoicedTo)}
            </div>
            <AddressDisplay
              address={parsedAddress}
              className={S.PaymentMethodDisplayAddressDisplay}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentMethodTypeInvoice
